import { useEffect, useState } from "react";
import { Shield, X } from "@phosphor-icons/react";
import api from "@/lib/api";

// Shown once per login session.
const SESSION_KEY = "ciq_privacy_ack";

export default function PrivacyDisclaimer() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) === "1") return;
    api.get("/legal/privacy-banner").then((r) => {
      setData(r.data);
      setOpen(true);
    });
  }, []);

  if (!open || !data) return null;

  const accept = () => {
    sessionStorage.setItem(SESSION_KEY, "1");
    setOpen(false);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end md:items-center justify-center bg-black/70 backdrop-blur-sm" data-testid="privacy-modal">
      <div className="relative w-full max-w-2xl theme-surface border theme-border p-8 mx-4 my-4 animate-slide-up">
        <div className="flex items-start gap-4">
          <Shield size={28} weight="fill" className="text-gold shrink-0 mt-1" />
          <div className="flex-1">
            <div className="overline">v{data.version}</div>
            <h2 className="font-serif-display text-3xl theme-ink mt-1">{data.title}</h2>
            <p className="text-sm theme-ink-muted mt-3 leading-relaxed">{data.body}</p>

            <div className="flex flex-wrap gap-x-5 gap-y-1 mt-4 text-xs">
              {data.links.map((l) => (
                <a key={l.href} href={l.href} target="_blank" rel="noreferrer" className="text-gold hover:underline">
                  {l.label} ↗
                </a>
              ))}
            </div>

            <button
              data-testid="privacy-accept-btn"
              onClick={accept}
              className="mt-6 bg-gold text-black px-6 py-2.5 text-sm font-medium rounded-sm hover:bg-[#e0bc40]"
            >
              I understand & continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
